import * as React from 'react';
import S from './NavigationSimpleMenu.styles';
const NavigationSimpleMenu = (props) => {
    const ref = React.useRef(null);
    const [offset, setOffset] = React.useState(0);
    const updateOffset = React.useCallback(() => {
        if (!ref.current) {
            return;
        }
        // Clear offset.
        setOffset(0);
        // Check with updated value.
        const rect = ref.current.getBoundingClientRect();
        const delta = Math.max(0, rect.right - window.innerWidth);
        setOffset(delta);
    }, []);
    React.useEffect(() => {
        updateOffset();
        window.addEventListener('resize', updateOffset);
        return () => window.removeEventListener('resize', updateOffset);
    }, [updateOffset]);
    return (React.createElement(S.Container, { ref: ref, style: { transform: `translateX(-${offset}px)` } },
        React.createElement(S.List, null, props.items.map((item, index) => (React.createElement(React.Fragment, null, !!item.text && item.url !== null && (React.createElement(S.Item, { key: item.id, ...(index === props.items.length - 1
                ? { onBlur: () => props.onActivateChange(false) }
                : {}) },
            React.createElement(S.Link, { href: item.url, target: item.target }, item.text)))))))));
};
export default NavigationSimpleMenu;
